// Single source of truth for the simulator estimate. Mirrored in backend/savings_formula.py.

export const REVENUE_RANGES = [
    { key: "lt2", label: "< 2 M€", avg: null, high: null },
    { key: "2-10", label: "2 – 10 M€", avg: 6e6, high: 10e6 },
    { key: "10-50", label: "10 – 50 M€", avg: 30e6, high: 50e6 },
    { key: "50-100", label: "50 – 100 M€", avg: 75e6, high: 100e6 },
    { key: "100-250", label: "100 – 250 M€", avg: 175e6, high: 250e6 },
    { key: "gt250", label: "> 250 M€", avg: 375e6, high: 500e6 },
];

export const BANK_OPTIONS = [
    { n: 1, label: "1 banque", noted: "1 banque" },
    { n: 2, label: "2 banques", noted: "2 banques" },
    { n: 3, label: "3 banques", noted: "3 banques" },
    { n: 4, label: "4 ou plus", noted: "4 banques ou plus" },
];

export const SHARE_RANGES = [
    { key: "lt25", label: "< 25 %", avg: 0.15, high: 0.25 },
    { key: "25-50", label: "25 – 50 %", avg: 0.375, high: 0.5 },
    { key: "gt50", label: "> 50 %", avg: 0.65, high: 0.8 },
];

export const OVERDRAFT_RANGES = [
    { key: "lt250k", label: "< 250 K€", avg: 150000, high: 250000 },
    { key: "250k-1m", label: "250 K€ – 1 M€", avg: 625000, high: 1000000 },
    { key: "gt1m", label: "> 1 M€", avg: 1500000, high: 2000000 },
];

// kind: "share" → CA × part × rate ; "overdraft" → découvert ; "info" → hors calcul
export const PARTICULARITIES = [
    { key: "intl", label: "Virements internationaux", kind: "share", rate: 0.0015 },
    { key: "change", label: "Opérations de change", kind: "share", rate: 0.0005 },
    { key: "credoc", label: "Crédits documentaires", kind: "share", rate: 0.015 },
    { key: "tpe", label: "Encaissements carte (TPE)", kind: "share", rate: 0.0075 },
    { key: "decouvert", label: "Découvert ou facilité de caisse utilisé", kind: "overdraft" },
    { key: "affacturage", label: "Affacturage", kind: "info" },
];

export const DEFAULT_RANGE = { share: "25-50", overdraft: "250k-1m" };

const byKey = (list, key) => list.find((x) => x.key === key);

// selected: { [particularityKey]: rangeKey | true }
function compute(revenueKey, banksCount, selected, level) {
    const ca = byKey(REVENUE_RANGES, revenueKey)[level];
    const n = Math.min(Math.max(banksCount, 1), 4);
    const base = ca * (0.0015 + 0.0005 * (n - 1));
    let flux = 0;
    let overdraft = 0;
    PARTICULARITIES.forEach((p) => {
        const r = selected[p.key];
        if (!r) return;
        if (p.kind === "share") flux += ca * byKey(SHARE_RANGES, r)[level] * p.rate;
        if (p.kind === "overdraft") {
            const d = byKey(OVERDRAFT_RANGES, r)[level];
            overdraft = 0.0125 * d + 350 * Math.ceil(d / 500000);
        }
    });
    return 0.55 * (base + flux) + overdraft;
}

export function estimateSavings(revenueKey, banksCount, selected = {}) {
    const range = byKey(REVENUE_RANGES, revenueKey);
    if (!range || range.avg === null) return null;
    const avg = compute(revenueKey, banksCount, selected, "avg");
    const high = compute(revenueKey, banksCount, selected, "high");
    return {
        average: Math.round(avg / 100) * 100,
        high: Math.ceil(Math.round(high) / 100) * 100,
        factoring: Boolean(selected.affacturage),
    };
}

export const formatEuro = (n) => `${new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(n).replace(/\s/g, "\u00a0")}\u00a0€`;
